import React from 'react';
import DefaultBrandImage from "../../assets/images/chat/company_placeholder_round.svg";
import CloseIcon from "../../assets/images/common/modals/close.svg";


function CompanyHeader({ company, handleCompanyChange }) {
    if (!company) return null;
    const companyName = company.name || "";
    const companyImage = company.image || DefaultBrandImage;
    return (
        <div className='company-header__content'>
            <div>
                <p className='title'>
                    <img className='logo' src={companyImage} alt="company-logo" />
                    {companyName}
                    <button className='button cursor-pointer' onClick={() => handleCompanyChange(null)}>
                        <img src={CloseIcon} alt="unselect-company" />
                    </button>
                </p>
                <div className='subtitle'>
                    <h6>{companyName} Reports</h6>
                    <p>Select a report below to start a conversation.</p>
                </div>

            </div>
        </div>
    )
}

export default CompanyHeader